module.exports = __webpack_public_path__ + "94606bed6e0a89b3b63f0d8968c522e2.svg";